import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { VehicleConstant } from "./VehicleConstant";

const initialState = {
  vehicleDataList: [],
  vehicledataloading: {
    isLoading: false,
  },

  postVehilceList: [{}],
  getVehiclesTypedata:[{}],
  getVehiclesSubTypedata:[{}],

  VehicleDropdownDataList: [],

  getMenufacturerdropdowndata:[],
  postVehilceBulkList: [{}],
  getModeldropdowndata:[],
  getVariantdropdowndata:[]
};

export const vehicleDataReducer = persistReducer(
  {
    storage,
    key: "vehicledata",
    whitelist: ["vehicleDataList,postVehilceList,DropdownDataList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case VehicleConstant.VEHICLE_REQUEST: {
        return {
          ...state,
          vehicleDataList: [],
          vehicledataloading: {
            isLoading: true,
          },
        };
      }

      case VehicleConstant.VEHICLE_RESPONSE: {
        return {
          ...state,
          vehicleDataList: payload,
          vehicledataloading: {
            isLoading: false,
          },
        };
      }

      case VehicleConstant.ADD_VEHICLE_RESPONSE: {
        return {
          ...state,
          postVehilceList: payload,
          postVehicle: {
            isLoading: false,
          },
        };
      }
      case VehicleConstant.ADD_VEHICLE_REQUEST: {
        return {
          ...state,
          postVehilceList: [],
          postVehicle: {
            isLoading: true,
          },
        };
      }

      case VehicleConstant.VEHICLE_DROPDOWN_REQUEST: {
        return {
          ...state,
          VehicleDropdownDataList: [],
          VehicleDropdowndata: {
            isLoading: true,
          },
        };
      }

      case VehicleConstant.VEHICLE_DROPDOWN_RESPONSE: {
        return {
          ...state,
          VehicleDropdownDataList: payload,
          VehicleDropdowndata: {
            isLoading: false,
          },
        };
      }
      case VehicleConstant.POST_VEHICLE_BULK_REQUEST: {
        return {
          ...state,
          postVehilceBulkList: [],
        };
      }

      case VehicleConstant.POST_VEHICLE_BULK_RESPONSE: {
        return {
          ...state,
          postVehilceBulkList: payload,
        };
      }
      case VehicleConstant.VEHICLE_GET_MENUFATURER_REQUEST: {
        return {
          ...state,
          getMenufacturerdropdowndata: [],
         
        };
      }
      case VehicleConstant.VEHICLE_GET_MENUFATURER_RESPONSE: {
        return {
          ...state,
          getMenufacturerdropdowndata: payload,
         
        };
      }

      case VehicleConstant.VEHICLE_MODEL_REQUEST: {
        return {
          ...state,
          getModeldropdowndata: [],
         
        };
      }
      case VehicleConstant.VEHICLE_MODEL_RESPONSE: {
        return {
          ...state,
          getModeldropdowndata: payload,
         
        };
      }
      case VehicleConstant.VEHICLE_VARIANT_DROPDOWN_REQUEST: {
        return {
          ...state,
          getVariantdropdowndata: [],
         
        };
      }
      case VehicleConstant.VEHICLE_VARIANT_DROPDOWN_RESPONSE: {
        return {
          ...state,
          getVariantdropdowndata: payload,
         
        };
      }

      case VehicleConstant.VEHICLE_TYPES_REQUEST: {
        return {
          ...state,
          getVehiclesTypedata: [],
         
        };
      }
      case VehicleConstant.VEHICLE_TYPES_RESPONSE: {
        return {
          ...state,
          getVehiclesTypedata: payload,
         
        };
      }
      case VehicleConstant.VEHICLE_SUB_TYPES_REQUEST: {
        return {
          ...state,
          getVehiclesSubTypedata: [],
         
        };
      }
      case VehicleConstant.VEHICLE_SUB_TYPES_RESPONSE: {
        return {
          ...state,
          getVehiclesSubTypedata: payload,
         
        };
      }
      default:
        return state;
    }
  }
);
